import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      ",
        ":after {\n        content: ' ",
        "';\n        pointer-events: none;\n        ",
        "\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    ",
        ":after {\n      content: ' \\2192';\n      pointer-events: none;\n      ",
        "\n    }\n\n    // Flipping arrow to left ← for RTL languages\n    [dir='rtl'] && ",
        ":after {\n      content: ' \\2190';\n      pointer-events: none;\n      ",
        "\n    }\n  "
    ], [
        "\n    ",
        ":after {\n      content: ' \\\\2192';\n      pointer-events: none;\n      ",
        "\n    }\n\n    // Flipping arrow to left ← for RTL languages\n    [dir='rtl'] && ",
        ":after {\n      content: ' \\\\2190';\n      pointer-events: none;\n      ",
        "\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { css } from "styled-components";
import FocusTrap from "../../focus-trap/FocusTrap";
var getArrowDirectionCSS = function(props) {
    if (!props.$withArrow) {
        return [];
    }
    /**
   * Used for hiding the arrow when the button has been clicked and
   * is showing the loading spinner.
   */ var loadingStateStyles = props.isLoading ? "\n  visibility: hidden;\n" : "";
    if (props.$arrowDirection) {
        return css(_templateObject(), FocusTrap, props.$arrowDirection, loadingStateStyles);
    }
    return css(_templateObject1(), FocusTrap, loadingStateStyles, FocusTrap, loadingStateStyles);
};
export default getArrowDirectionCSS;
